import request from '@/utils/request'

export function getApproveItemList(data) {
  return request.post('/approve-item/list', data)
}

export function addApproveItem(data) {
  return request.post('/approve-item/add', data)
}

export function modifyApproveItem(data) {
  return request.post('/approve-item/modify', data)
}

export function deleteApproveItem(data) {
  return request.post('/approve-item/delete', data)
}



// WEBPACK FOOTER //
// ./src/api/settings/approve-item.js